import React, { useEffect } from 'react'
import '../GeneracionFactura/styles/TableBienes.css'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {ProductosF} from '../../../../interfaces/facturacion.interface'
import TablaFacturacionCF from '../GeneracionFactura/TablaFacturacionCF'
import { bindActionCreators } from 'redux'
import { actionFacturacionProducto } from '../../../../actions/action-creators'

const TablaResumenCF = () => {
  const arrayProductos: Array<ProductosF> = useSelector((state: State) => state.facturacion.arrayProductos)
  const calculos = useSelector((state: State) => state.facturacion.calculosArrayProductos)
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const checkContribuyente = useSelector((state: State) => state.facturacion.formCliente.checkContribuyente)
  const checkExentoImpuesto = useSelector((state: State) => state.facturacion.formCliente.checkExentoImpuesto)
  const checkVentasNoSujetas = useSelector((state: State) => state.facturacion.formCliente.checkVentasNoSujetas)
  const checkPropina = useSelector((state: State) => state.facturacion.formCliente.checkPropina)
  const userLogin = useSelector((state: State) => state.userLogin)
  const dispatch = useDispatch()
  const {facturacionCalculoTotalArrayProducto} = bindActionCreators(actionFacturacionProducto, dispatch)
  
  useEffect(() => {
    facturacionCalculoTotalArrayProducto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayProductos])


  return (
    <div className='w-layout-vflex card-content'>
      <TablaFacturacionCF propina={userLogin?.propina} datos={calculos} arrayProductos={arrayProductos} rows={arrayProductos} sinAcciones={true} idDoc={idDoc} checkContribuyente={checkContribuyente} checkExentoImpuesto={checkExentoImpuesto} checkPropina={checkPropina} checkVentasNoSujetas={checkVentasNoSujetas} />
    </div>
  )
}

export default TablaResumenCF
